import React from 'react';
import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Images from '../../../Configs/images';
import Carousel from '../../Elements/Carousel';

export default function Component() {
  const data = [
    Images.TestImg,
    Images.TestImg,
    Images.TestImg,
    Images.TestImg,
  ];
  const { t } = useTranslation();
  return (
    <>
      <Container sx={{ mb: 1.5 }}>
        <div className="flex space-between align-items-center">
          <div>
            <div className="weight-700">
              {t('homePage.academy')}
            </div>
            <div className="s-10">
              {t('homePage.academyDesc')}
            </div>
          </div>
        </div>
      </Container>
      <Carousel data={data} itemWidth={0.4} />
    </>
  );
}
